// @flow
import cookiesPolicy from 'fg-frontend/components/CookiesPolicy4/index';
cookiesPolicy({
  position: 'bottom',
  enableModal: true,
  imgSrc: '/img/cookie-policy/cookie.svg',
});

import connectWebActions from 'fg-frontend/src/webComponents/connectWebActions';
import { connectWebComponents } from 'fg-frontend/src/webComponents/decorate';
import autoTitleLinksWithBlankTarget from 'fg-frontend/src/components/autoTitleLinksWithBlankTarget';
import safeBlankLinks from 'fg-frontend/src/components/safeBlankLinks';

import configureWebComponents from './configureWebComponents';
import configureWebActions from './configureWebActions';
import phoneLink from 'fg-frontend/components/PhoneLink';
import 'fg-frontend/ramjet/liveValidation';


import('./components/plUpload/fg.upload');
// import 'bootstrap/js/dist/collapse';

// import('fg-frontend/src/components/fileInput/FileInput');

connectWebComponents(configureWebComponents);
connectWebActions(configureWebActions, [ 'keyup' ]);
autoTitleLinksWithBlankTarget();
phoneLink();

// Mastaveni atributu 'noopener' vsem target="_blank" odkazum, ktere ho nemaji
safeBlankLinks();



// WEBPACK FOOTER //
// ./fe/web-default/src/js/configureWeb.js